module.exports = __webpack_public_path__ + "img/building.f6cba20d.jpg";